import { Route, lazyRouteComponent } from "@tanstack/react-router";
import { rootRoute } from "./root";

export const whiteLabelRoute = new Route({
  getParentRoute: () => rootRoute,
  path: "/white-label",
  component: lazyRouteComponent(() => import("../pages/white-label")),
});
